import { render, staticRenderFns } from "./phoneLogin.vue?vue&type=template&id=bcea308a&scoped=true&"
import script from "./phoneLogin.vue?vue&type=script&lang=js&"
export * from "./phoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./phoneLogin.vue?vue&type=style&index=0&id=bcea308a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcea308a",
  null
  
)

export default component.exports